<p>{{ 'adminUsers.user' | translate }}: {{ username }}</p>
<nz-select
  class="set-roles-modal__select"
  nzMode="multiple"
  [(ngModel)]="selectedRoles"
  [nzPlaceHolder]="'adminUsers.rolesPlaceholder' | translate"
>
  @for (role of availableRoles; track role.name) {
    <nz-option [nzValue]="role.name" [nzLabel]="role.labelKey | translate"></nz-option>
  }
</nz-select>
